<template>
  <div class="component-container">
    <draggable class="draggable selected-list" :value="value" @input="emitInput">
      <div class="product-item item"
        v-for="(item,index) in value"
        :key="item.id">
        <div class="img">
          <img :src="item.thumb" v-img-auto>
        </div>
        <div class="name">{{item.title}}</div>
        <div class="price">
          <span>￥{{item.price/100}}</span>
        </div>
        <div class="close" @click="deleteItem(item,index)"></div>
      </div>
      <div class="add-btn" @click="showLayer">+</div>
    </draggable>
    <el-dialog :append-to-body="true" title="选择商品" center :visible.sync="dialogVisible" width="1000px">
      <div class="select-product">
        <el-form :inline="true" label-width="100px">
          <el-form-item>
            <el-input v-model="form.keyword" @input="getProductList" placeholder="商品名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-cascader
              :options="groupList"
              v-model="category_id"
              change-on-select
              :props="{value:'id',label:'title',children:'sub_categories'}"
              @change="changeHandle"
              style="width:140px;">
            </el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select v-model="form.brand_id" @change="getProductList" clearable placeholder="品牌" style="width:140px;">
              <el-option label="全部品牌" value=""></el-option>
              <el-option v-for="item in brandList" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="form.series_id" @change="getProductList" clearable placeholder="系列" style="width:140px;">
              <el-option label="全部系列" value=""></el-option>
              <el-option v-for="item in seriesList" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="tips">
          <span>已选择 {{selectedList.length}}/{{limit}}</span>
        </div>
        <div class="container">
          <div class="product-item"
            v-for="item in productList"
            :class="{active:uuid.indexOf(item.uuid)>-1}"
            :key="item.id"
            @click="selectCurrentItem(item)">
            <div class="img">
              <img :src="item.thumb" v-img-auto>
            </div>
            <div class="name">{{item.title}}</div>
            <div class="price">
              <span>￥{{item.price/100}}</span>
            </div>
            <!-- <span class="a-tips">集赞</span>
            <span class="a-tips">拼团</span> -->
            <span class="selected-label"></span>
          </div>
        </div>
        <div class="no-product" v-if="is_init&&productList.length===0">暂无数据</div>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="form.page"
          :page-size="form.per_page"
          layout="total, prev, pager, next"
          :total="total"
          style="margin-top:10px;">
        </el-pagination>
        <div class="btn-group" style="margin-top:10px;">
          <el-button type="primary" @click="clickHandle">确认选择</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import request from '@/utils/request'
export default {
  name: 'SelectProduct',
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      default: _ => {
        return []
      }
    },
    limit: {
      type: Number,
      default: 30
    }
  },
  data () {
    return {
      dialogVisible: false,
      groupList: [],
      brandList: [],
      seriesList: [],
      form: {
        brand_id: '',
        series_id: '',
        category_id: '',
        per_page: 21,
        page: 1,
        keyword: ''
      },
      category_id: [],
      total: 0,
      productList: [],
      selectedList: [],
      is_init: false,
      dataInit: false
    }
  },
  computed: {
    uuid () {
      let uuid = ''
      this.selectedList.forEach(item => {
        uuid = uuid + '_' + item.uuid
      })
      return uuid
    }
  },
  watch: {
    value: {
      handler (value) {
        if (value.length) {
          this.selectedList = JSON.parse(JSON.stringify(value))
        } else {
          this.selectedList = []
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.getProductList()
  },
  methods: {
    initData () {
      if (!this.dataInit) {
        this.dataInit = true
        request({
          url: 'categories?type=global'
        }).then(res => {
          this.groupList = res.data.list
          this.groupList.unshift({
            title: '全部分类',
            id: '',
            sub_categories: []
          })
        })
        request({
          url: 'brands'
        }).then(res => {
          this.brandList = res.data.list
        })
        request({
          url: 'series'
        }).then(res => {
          this.seriesList = res.data.list
        })
      }
    },
    showLayer () {
      this.dialogVisible = true
      this.initData()
    },
    changeHandle (e) {
      if (e.length) {
        this.form.category_id = e[e.length-1]
      }
      this.getProductList()
    },
    getProductList () {
      let form = this.form
      let sendData = {
        status: 1,
        brand: form.brand_id,
        series: form.series_id,
        category: form.category_id,
        per_page: form.per_page,
        page: form.page,
        key: form.keyword
      }
      request({
        url: 'products',
        method: 'get',
        params: sendData
      }).then(res => {
        this.is_init = true
        this.productList = res.data.list
        this.total = res.data.item_total
      })
    },
    handleCurrentChange (e) {
      this.form.page = e
      this.getProductList()
    },
    selectCurrentItem (item) {
      let selected = false
      let selectedList = this.selectedList
      for (let i = 0; i < selectedList.length; i++) {
        if (item.uuid === selectedList[i].uuid) {
          selectedList.splice(i, 1)
          selected = true
          break
        }
      }
      if (!selected) {
        if (this.limit > selectedList.length) {
          selectedList.push({
            id: item.id,
            uuid: item.uuid,
            thumb: item.thumb,
            title: item.title,
            price: item.price
          })
        }
      }
    },
    clickHandle () {
      this.emitInput(this.selectedList)
      this.dialogVisible = false
    },
    deleteItem (item, index) {
      this.selectedList.splice(index, 1)
      this.emitInput(this.selectedList)
    },
    emitInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style lang="less" scoped>
@height: 90px;
.selected-list {
  display: flex;
  flex-wrap: wrap;
  .product-item {
    position: relative;
    cursor: pointer;
    width: 90px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 5px;
    border: 1px solid #E4E7ED;
    box-sizing: border-box;
    .img {
      width: 100%;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .name {
      font-size: 12px;
      color: #666666;
      text-align: center;
      line-height: 15px;
      height: 15px;
      word-break: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .price {
      font-size: 12px;
      color: #F56C6C;
      text-align: right;
      line-height: 15px;
    }
    .close {
      position: absolute;
      right: -5px;
      top: -5px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBoZWlnaHQ9IjIwMCIgd2lkdGg9IjIwMCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHQ9IjE0OTI2NjEzOTM1NTIiIGNsYXNzPSJpY29uIiBzdHlsZT0iIiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgcC1pZD0iMTU1NCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNMzUxLjkxMyAyOTEuNTI4bDM4Ni4wMDcgMzg2LjAwNy01MS40MzYgNTEuNDM2LTM4Ni4wMDctMzg2LjAwNyA1MS40MzYtNTEuNDM2eiIgcC1pZD0iMTU1NSI+PC9wYXRoPjxwYXRoIGQ9Ik02ODYuNTE2IDI5MS41MjhsNTEuNDM2IDUxLjQzNi0zODYuMDA3IDM4Ni4wMDctNTEuNDM2LTUxLjQzNiAzODYuMDA3LTM4Ni4wMDd6IiBwLWlkPSIxNTU2Ij48L3BhdGg+PHBhdGggZD0iTTUxMiAxMDAxLjY4OWMtMjcwLjkyMSAwLTQ5MS4zMDItMjIwLjM4Mi00OTEuMzAyLTQ5MS4zODdzMjIwLjM4Mi00OTEuMzAyIDQ5MS4zMDItNDkxLjMwMiA0OTEuMzAyIDIyMC4zODIgNDkxLjMwMiA0OTEuMzg3LTIyMC4zODIgNDkxLjMwMi00OTEuMzAyIDQ5MS4zMDJ6TTUxMiA5MS43NDFjLTIzMC44MjEgMC00MTguNTYgMTg3LjczOS00MTguNTYgNDE4LjU2czE4Ny43MzkgNDE4LjU2IDQxOC41NiA0MTguNTYgNDE4LjU2LTE4Ny43MzkgNDE4LjU2LTQxOC41Ni0xODcuNzM5LTQxOC41Ni00MTguNTYtNDE4LjU2eiIgcC1pZD0iMTU1NyI+PC9wYXRoPjwvc3ZnPg==);
      background-size: 100%;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    .change {
      position: absolute;
      width: 100%;
      line-height: 20px;
      text-align: center;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5)
    }
  }
  .add-btn {
    cursor: pointer;
    width: @height;
    height: @height;
    border: 1px dashed #999999;
    text-align: center;
    line-height: @height;
  }
}
.select-product {
  .el-form-item {
    margin-bottom: 10px;
  }
  .tips span {
    line-height: 20px;
    display: inline-block;
    padding: 2px 5px;
    border-radius: 3px;
    background-color: #67C23A;
    color: #fff;
    font-size: 12px;
  }
  .container {
    display: flex;
    margin-top: 10px;
    flex-wrap: wrap;
    .product-item {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      width: 120px;
      margin-right: 8px;
      margin-bottom: 8px;
      padding: 5px;
      border: 1px solid #E4E7ED;
      box-sizing: border-box;
      .selected-label {
        position: absolute;
        padding: 10px;
        top: -10px;
        right: -10px;
        display: none;
        background-color: #409EFF;
        transform: rotate(45deg);
      }
      &.active {
        border: 1px solid #409EFF;
        background-color: #F2F6FC;
        .selected-label {
          display: block;
        }
      }
      .img {
        width: 100%;
        height: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .name {
        font-size: 13px;
        color: #666666;
        text-align: center;
        line-height: 17px;
        height: 35px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .price {
        font-size: 13px;
        color: #F56C6C;
        text-align: right;
        line-height: 17px;
      }
    }
  }
  .no-product {
    width: 100%;
    line-height: 200px;
    text-align: center;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelectProduct/SelectProduct.vue